import type { SVGProps } from 'react';

const SvgArrowDropUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="m7 14 5-5 5 5z" />
  </svg>
);
export default SvgArrowDropUp;
